import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 10 10",
  height: "48",
  width: "48",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", null, [
      _createElementVNode("path", {
        d: "M9.68,4.23,5.43.23a.64.64,0,0,0-.86,0l-4.25,4a.64.64,0,0,0,0,.89.63.63,0,0,0,.89,0L5,1.55,8.82,5.14a.6.6,0,0,0,.43.17.62.62,0,0,0,.43-1.08Z",
        fill: "currentColor"
      }),
      _createElementVNode("path", {
        d: "M5.35,3.08a.5.5,0,0,0-.7,0l-3,3a.49.49,0,0,0-.15.36v3a.5.5,0,0,0,.5.5H8a.5.5,0,0,0,.5-.5v-3a.49.49,0,0,0-.15-.36Z",
        fill: "currentColor"
      })
    ], -1)
  ])))
}
export default { render: render }